class PdpGallery extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.pdp-gallery__slide'));
    this.thumbs = Array.from(this.querySelectorAll('.pdp-gallery__thumb'));
    this.prevButton = this.querySelector('.pdp-gallery__arrow--prev');
    this.nextButton = this.querySelector('.pdp-gallery__arrow--next');
    this.viewport = this.querySelector('.pdp-gallery__viewport');
    this.index = this.slides.findIndex((slide) => slide.classList.contains('is-active'));
    if (this.index < 0) this.index = 0;

    this.thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => this.goTo(Number(thumb.dataset.index)));
    });
    this.prevButton?.addEventListener('click', () => this.goTo(this.index - 1));
    this.nextButton?.addEventListener('click', () => this.goTo(this.index + 1));

    this.viewport?.addEventListener('touchstart', (event) => this.handleTouchStart(event), { passive: true });
    this.viewport?.addEventListener('touchend', (event) => this.handleTouchEnd(event), { passive: true });
    this.viewport?.addEventListener('scroll', () => this.handleScroll(), { passive: true });

    this.render();
  }

  isMobileScroll() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  handleTouchStart(event) {
    if (this.isMobileScroll()) return;
    this.touchStartX = event.changedTouches[0].screenX;
    this.touchStartY = event.changedTouches[0].screenY;
  }

  handleTouchEnd(event) {
    if (this.isMobileScroll()) return;
    if (this.touchStartX === undefined) return;
    const deltaX = event.changedTouches[0].screenX - this.touchStartX;
    const deltaY = event.changedTouches[0].screenY - this.touchStartY;
    const threshold = 40;

    if (Math.abs(deltaX) < threshold || Math.abs(deltaX) < Math.abs(deltaY)) return;

    if (deltaX < 0) {
      this.goTo(this.index + 1);
    } else {
      this.goTo(this.index - 1);
    }
  }

  handleScroll() {
    if (!this.isMobileScroll() || !this.viewport) return;
    clearTimeout(this.scrollTimer);
    this.scrollTimer = setTimeout(() => {
      const width = this.viewport.clientWidth;
      if (!width) return;
      const newIndex = Math.round(this.viewport.scrollLeft / width);
      if (newIndex !== this.index && newIndex >= 0 && newIndex < this.slides.length) {
        this.index = newIndex;
        this.render();
      }
    }, 100);
  }

  goTo(index) {
    if (index < 0 || index >= this.slides.length) return;
    this.index = index;
    if (this.isMobileScroll() && this.viewport) {
      this.viewport.scrollTo({ left: this.slides[index].offsetLeft, behavior: 'smooth' });
    }
    this.render();
  }

  render() {
    this.slides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === this.index);
    });
    this.thumbs.forEach((thumb, i) => {
      const active = i === this.index;
      thumb.classList.toggle('is-active', active);
      thumb.setAttribute('aria-current', active ? 'true' : 'false');
    });

    if (this.prevButton) this.prevButton.hidden = this.index === 0;
    if (this.nextButton) this.nextButton.hidden = this.index === this.slides.length - 1;
  }
}

customElements.define('pdp-gallery', PdpGallery);
